const DEFAULT_META = Object.freeze({
  version: "0.0.0",
  buildId: "unknown",
  builtAt: null,
});

let cachedMeta = null;
let loadPromise = null;

const safeFreeze = (value) => {
  try {
    return Object.freeze(value);
  } catch {
    return value;
  }
};

export const getBuildMetaSync = () => {
  return cachedMeta || DEFAULT_META;
};

export const loadBuildMeta = async () => {
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    const publicUrl = process.env.PUBLIC_URL || "";
    const url = `${publicUrl}/build-meta.json`;
    try {
      const resp = await fetch(url, { cache: "no-store" });
      if (!resp.ok) throw new Error(`Failed to load build meta (${resp.status})`);
      const json = await resp.json();

      const version =
        typeof json?.version === "string" && json.version.trim()
          ? json.version.trim()
          : DEFAULT_META.version;
      const buildId =
        typeof json?.buildId === "string" && json.buildId.trim()
          ? json.buildId.trim()
          : DEFAULT_META.buildId;
      const builtAt =
        typeof json?.builtAt === "string" && json.builtAt.trim()
          ? json.builtAt.trim()
          : DEFAULT_META.builtAt;

      cachedMeta = safeFreeze({ version, buildId, builtAt });
    } catch {
      cachedMeta = DEFAULT_META;
    }

    try {
      window.__APP_BUILD__ = cachedMeta;
    } catch {}

    return cachedMeta;
  })();

  return loadPromise;
};

